import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import AboutPage from './Pages/AboutPage';
import Rooms from './Pages/Rooms';
import Header from './Component/NavBar/Header';
import RoomDetailsPage from './Component/RoomDetails/RoomDetailsPage';
import ReviewBooking from "./Component/BookingReview/ReviewBooking";
import SuccessPage from "./Component/Congratulation/SuccessPage";
import Account from './Pages/Account';
import Contact from './Pages/Contact';
import Eventsdata from './Data/Eventsdata';
import Events from './Pages/Events';
import Gallery from './Pages/Gallery';
import Attractions from './Pages/Attractions';
import RoomData from './Component/RoomData';
import Notfound from './Pages/Notfound';

function App() {
  // Use the useLocation hook to get the current path
  const location = useLocation();

  // List of paths where the header should be hidden
  const hideHeaderPaths = ['/success' || "/account"];

  return (
    <div className="App">
      {/* Conditionally render the Header */}
      {!hideHeaderPaths.includes(location.pathname) && <Header />}
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/top-resort-neral' element={<AboutPage />} />
        <Route path='/resort-with-rooms-neral' element={<Rooms />} />
        <Route path='/family-resort-neral' element={<Gallery/>}/>
        <Route path='/best-resort-neral' element={<Attractions/>}/>
        {Eventsdata.map((data) => (
            <Route path={data.slugs} element={<Events />} />
          ))}    
              {/* <Route path='/booking/:room_id' element={<ReviewBooking />} /> */}

{RoomData.map((data) => (
            <Route path={data.slug} element={<RoomDetailsPage />} />
          ))} 
        {/* <Route path='/RoomDetailsPage/:room_id' element={<RoomDetailsPage />} />
        <Route path='/success' element={<SuccessPage />} /> */}
        {/* <Route path="/account/:page" element={<Account />} /> */}
        <Route path='/resort-near-neral' element={<Contact/>}/>
        <Route path="*" element={<Notfound />} />

      </Routes>
    </div>
  );
}

export default function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
